import PermissionTableContainer from '../PermissionTable';
import './Body.scss';
import ModalDeletePermission from '../../components/Modals/ModalDeletePermission';
import ModalCreateEditPermission from '../../components/Modals/ModalCreateEditPermission';
import CreatePermission from '../CreatePermission/CreatePermission';
import { Button, Input, message } from 'antd';
import { useState } from 'react';
import { downloadPermissions } from '../../services/services';
import { useTranslation } from 'react-i18next';

const Body = (): JSX.Element => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onFilterChange = (event: any) => {
    const { value } = event.target;
    setFilter(value);
  };

  const handledownloadPermissions = () => {
    setIsLoading(true);
    downloadPermissions()
      .then(() => {
        setIsLoading(false);
        message.success({
          content: t('placeholders.downloadSuccess')
        });
      })
      .catch(() => {
        setIsLoading(false);
        message.error({
          content: t('placeholders.downloadError')
        });
      });
  };

  return (
    <>
      <div className="body-container">
        <div className="container">
          <Input
            placeholder={t('placeholders.permissionSearch')}
            style={{ width: '300px' }}
            onChange={onFilterChange}
          />
          <div className="buttons-container">
            <CreatePermission />
            <Button loading={isLoading} onClick={handledownloadPermissions} type="primary">
              {`${t('placeholders.downloadButton')}`}
            </Button>
          </div>
        </div>
        <PermissionTableContainer filter={filter} />
      </div>
      <ModalDeletePermission />
      <ModalCreateEditPermission />
    </>
  );
};

export default Body;
